import { render, staticRenderFns } from "./AdminConfiguration.vue?vue&type=template&id=09084698&scoped=true"
import script from "./AdminConfiguration.vue?vue&type=script&lang=js"
export * from "./AdminConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AdminConfiguration.vue?vue&type=style&index=0&id=09084698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09084698",
  null
  
)

export default component.exports